// Renamed from GiftLandingPage.js
import React from 'react';
import GiftLandingPage from './GiftLandingPage';

const GiftOfSleep = () => {
  return <GiftLandingPage />;
};

export default GiftOfSleep;
